import React from 'react';
import { observer } from 'mobx-react';
import withDialog from 'lib/alerts/with-dialog';
import Styled from 'styled';
import Localizable from 'lib/intl/localizable';

import ImagesPreview from 'four-nets/ui-v2/form/images-preview/images-preview';
import FileThumbnail from 'four-nets/ui-v2/form/images-preview/file-thumbnail';

import PhotoFileInputView from './photofile-input-view';
import defaultStyles from './photofile-upload-view.scss';

@withDialog
@Localizable()
@Styled(defaultStyles)
@observer
class PhotoFileUploadView extends React.Component {
    render() {
        const { field, styles, ...rest } = this.props;

        return (
            <div className={styles.photoFileUpload}>
                <div className={styles.input}>
                    <PhotoFileInputView field={field} {...rest} />
                </div>
                <div className={styles.uploadList}>
                    <ImagesPreview field={field} thumbnail={<FileThumbnail />} />
                </div>
            </div>
        );
    }
}

export default PhotoFileUploadView;
